import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import rawMatIcon from "../../../../../assets/new-product-detail-cats/header-icons/raw-material-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getProductInventory } from "../../../../../apis/Product/ProductInventoryApi";
import { createSystemBoundaryProductInventory } from "../../../../../apis/Product/ProductInventoryApi";
import { fetchFlow31AggregatedImpactTotals } from "./flow31ImpactTotals";

const RawMaterialIcon = () => (
  <img src={rawMatIcon} alt="Raw Material Icon" width={76} height={76} />
);

const RawMaterialHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  handleShowCategory,
  isCategory,
  showCategory,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalProdItem, setTotalProdItem] = useState([]);
  const [systemBoundaryItem, setSystemBoundaryItem] = useState("");
  const [flow31ImpactTotals, setFlow31ImpactTotals] = useState(null);

  useEffect(() => {
    getProductInventory({
      id: productId,
      setProdInv: setTotalProdItem,
      setSystemBoundary: setSystemBoundaryItem,
    });
  }, [productId]);

  useEffect(() => {
    let cancelled = false;
    if (!productId) {
      setFlow31ImpactTotals(null);
      return undefined;
    }
    fetchFlow31AggregatedImpactTotals(productId).then((totals) => {
      if (!cancelled) setFlow31ImpactTotals(totals);
    });
    return () => {
      cancelled = true;
    };
  }, [productId]);
  return (
    <CategoryComponent
      show={show}
      className={`raw-material-category ${className || ""}`}
      leftBoxProps={{
        icon: <RawMaterialIcon />,
        title: t("RAW_MATERIALS"),
        description: t("RAW_MATERIALS_INTRO"),
        productId: productId,
        isSystemBoundary: true,
        systemBoundary: systemBoundaryItem,
        setSystemBoundary: setSystemBoundaryItem,
        createSystemBoundaryFunc: createSystemBoundaryProductInventory,
        handleShowCategory: handleShowCategory,
        isCategory: isCategory,
        showCategory: showCategory,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_31") || "Total for Flow 31",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: flow31ImpactTotals,
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default RawMaterialHeader;
